export default __webpack_public_path__ + "static/media/31.9859fbac.png";